// src/pages/AboutPage.js
import React from 'react';
import sgbauLogo from '../images/sgb-amravti.png';

const AboutPage = () => {
  return (
    <article id="about" className="content-section">
      <h2 className="section-title">About College</h2>
      <div className="about-content">
        <img src={sgbauLogo} alt="SGBAU Logo" className="about-logo" />
        <div className="about-text">
          <p>Late Sanjay Tompe & Late Samir Deshmukh Shikshanshastra Mahavidyalaya, Chandur Bazar was established in 2008 and is run by well known G.S. Tompe Sarvajanik Trust, Chandur Bazar founded by Shri. Govindrao Tompe. The College is affiliated to Sant Gadge Baba Amravati University, Amravati (ms) India and is located in the heart of Chandur Bazar city. The college have two storied building, a huge play ground, girl's hostel and ample resources for Education and Physical Education Studies. Principal and the staff of college always take initiatives to conduct various activities and exert for the betterment of student's mental and physical performance.</p>
        </div>
      </div>
    </article>
  );
};

export default AboutPage;
